import React from 'react';
import firebase, {auth} from '../firebase';
import * as Yup from 'yup';
import language from '../languages';

const meta = (lang)=> {
    return {
        entityName: language[lang].Profile,
        emptyRow: () => {
            return {
                isMaintenance: false,
                title: '',
                msg: '',
                image: 'https://via.placeholder.com/800'
            }
        },
        collection: 'maintenance',
        addButtonText: 'Maintenance',
        // addButtonText: () => {
        //     return <>Add New </>
        //     },
        hideTitle: true,
        docPath: 'config',
        fields: [
            {name: 'isMaintenance', default: false, dataType: 'boolean', label: 'On Maintenance', input: 'switch', color: 'primary'},
            {name: 'title', default: null, dataType: 'string', label: 'Title', input: 'text'},
            {name: 'msg', default: null, dataType: 'string', label: 'Message', input: 'text'},
            {name: 'image', default: null, dataType: 'string', label: 'Image', input: 'file'},
        ],
        validationSchema: Yup.object({
            title: Yup.string(),
            msg: Yup.string(),
        }),
        filterObject: [],
        beforeSave: (user, doc)=> {
            // if(doc.releaseDate){
            //     doc.releaseDate = new Date(doc.releaseDate).getTime();
            // }
            return doc
        }
    }
}

export default meta;